'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var React = require('react');
var coreComponentsSkeleton = require('@alfalab/core-components-skeleton');
var components_option_Component = require('../../components/option/Component.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

var styles = {"skeleton":"select__skeleton_1g17h"};
require('./index.css')

function useSelectWithLoading(_a) {
    var _b = _a.loading, loading = _b === void 0 ? false : _b, _c = _a.visibleOptions, visibleOptions = _c === void 0 ? 6 : _c, _d = _a.Option, Option = _d === void 0 ? components_option_Component.Option : _d;
    var renderOption = function (props) { return (React__default.default.createElement(Option, tslib.__assign({}, props, { Checkmark: null, highlighted: loading ? false : props.highlighted }))); };
    var options = Array(visibleOptions)
        .fill(0)
        .map(function (_, key) { return ({
        key: "loading-".concat(key),
        disabled: true,
        content: React__default.default.createElement(coreComponentsSkeleton.Skeleton, { className: styles.skeleton, visible: true }),
    }); });
    if (!loading)
        return null;
    return {
        Option: renderOption,
        options: options,
    };
}

exports.useSelectWithLoading = useSelectWithLoading;
